"use client"

import { PropsWithChildren } from "react"
import { AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion"
import { cn } from "../lib/utils"

type DashboardAccordionProps = PropsWithChildren & {
    className?: string,
    heading: string,
    /** Optional class for the heading text (e.g. workscope category color: relief=red, rebuilding=blue, goodwill=green) */
    headingClassName?: string
}

const DashboardAccordion = ({ children, className, heading, headingClassName }: DashboardAccordionProps) => {
    return (
        <AccordionItem
            className={cn(
                'bg-muted rounded p-4 border flex flex-col gap-3 transition-colors duration-200',
                className
            )}
            value={heading}
        >
            <AccordionTrigger className='py-0 p-1' downChevronIconClassName='w-5 h-5'>
                <h2 className={cn("text-xl font-semibold", headingClassName)}>{heading}</h2>
            </AccordionTrigger>
            <AccordionContent className='pb-0 p-1'>
                {children}
            </AccordionContent>
        </AccordionItem>
    )
}

export default DashboardAccordion